export const associations = (state) => state.associations;
export const parties = (state) => state.parties;
export const party = (state) => state.party;